import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import React, { useContext } from "react";
import Loading from "../loading";
import GoogleFontLoader from "./FontLoader/index";
import { useBrandingFetch } from "./useBrandingFetch";
export function getCssVarValue(cssVar) {
    return getComputedStyle(document.body).getPropertyValue(cssVar).trim();
}
export var TextAlignEnum;
(function (TextAlignEnum) {
    TextAlignEnum["CENTER"] = "center";
    TextAlignEnum["INHERIT"] = "inherit";
    TextAlignEnum["JUSTIFY"] = "justify";
    TextAlignEnum["LEFT"] = "LEFT";
    TextAlignEnum["RIGHT"] = "RIGHT";
})(TextAlignEnum || (TextAlignEnum = {}));
export const defautTextValue = {
    Alignment: "left",
    FontSize: "",
    FontStyle: "",
    TextColor: "",
    Uppercase: false,
};
export const BrandingProvider = ({ children }) => {
    const { branding, fonts, loading, theme: NEW_THEME } = useBrandingFetch();
    if (loading || !branding)
        return _jsx(Loading, {});
    return (_jsx(StyledEngineProvider, Object.assign({ injectFirst: true }, { children: _jsxs(ThemeProvider, Object.assign({ theme: NEW_THEME }, { children: [fonts.length > 0 && _jsx(GoogleFontLoader, { fonts: fonts }), _jsx(BrandingContext.Provider, Object.assign({ value: { branding } }, { children: children }))] })) })));
};
export const BrandingContext = React.createContext({
    branding: {
        BrandDisplayName: { Input: "" },
        BrandEmail: { Input: "" },
        BrandLogo: { FileUpload: undefined, IsWhite: false },
        BrandURL: { Input: "" },
        OrderFlowMyMealsCartIcon: { FileUpload: undefined, IsWhite: false },
        SiteBodyBg: { Color: "" },
    },
});
export const useBranding = () => useContext(BrandingContext);
